import { createSlice } from '@reduxjs/toolkit';

import { CoverageTypes, Fields } from '../Constant';
import { RESET_ALL } from 'constants/enum';
import { Services } from 'services/api/services';
import {
  priceUpdateResponseDecorator,
  vixResponseDecorator
} from 'services/decorators/responses';
import { loadFromSessionStorage, saveToSessionStorage } from 'util/helper';

export const COVERAGE_SUM_INSURED_SS_KEY = 'coverageSumInsured';

export const initialState = loadFromSessionStorage(COVERAGE_SUM_INSURED_SS_KEY) || {
  [Fields.COVERAGE_TYPE]: CoverageTypes.COMPREHENSIVE.value,
  [Fields.SUM_INSURED]: undefined
};

export const coverageType = {
  Comprehensive: CoverageTypes.COMPREHENSIVE.value,
  'Third Party, Fire & Theft': CoverageTypes.THIRD_PARTY_FIRE_THEFT.value
};

export const coverageSumInsuredSlice = createSlice({
  name: 'coverageSumInsured',
  initialState,
  reducers: {
    setFieldValue: (state, action) => {
      state[Fields.SUM_INSURED] = action.payload;
      saveToSessionStorage(COVERAGE_SUM_INSURED_SS_KEY, state);
    },
    setButtonType: (state, action) => {
      state[Fields.COVERAGE_TYPE] =
        coverageType[action.payload] || action.payload;
      saveToSessionStorage(COVERAGE_SUM_INSURED_SS_KEY, state);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(RESET_ALL, () => initialState)
      .addMatcher(
        Services.endpoints.getVehicleInformation.matchFulfilled,
        (state, { payload }) => {
          const { applicationInformation, vehicleDetails } =
            vixResponseDecorator(payload);
          state[Fields.SUM_INSURED] =
            applicationInformation?.extra?.sum_insured ||
            vehicleDetails?.ism_insured_value;
          state[Fields.COVERAGE_TYPE] =
            applicationInformation?.extra?.coverage_type || state.COVERAGE_TYPE || CoverageTypes.COMPREHENSIVE.value;
          saveToSessionStorage(COVERAGE_SUM_INSURED_SS_KEY, state);
        }
      )
      .addMatcher(
        Services.endpoints.updateSelectedAddOns.matchFulfilled,
        (state, action) => {
          const { response } = action.payload;
          const {
            aig: { aigData },
            zurich: { zurichData }
          } = priceUpdateResponseDecorator(response);
          if (zurichData) {
            state[Fields.SUM_INSURED] = zurichData?.insurer_sum_insured_value;
          }
          if (aigData) {
            state[Fields.SUM_INSURED] = aigData?.insurer_sum_insured_value;
          }
          saveToSessionStorage(COVERAGE_SUM_INSURED_SS_KEY, state);
        }
      );
  }
});

export const { setButtonType, setFieldValue } = coverageSumInsuredSlice.actions;

export default coverageSumInsuredSlice.reducer;
